module.exports = __webpack_public_path__ + "static/media/extension.128.56515d3c.svg";